import { openDigitalTwin } from "../components/HomeDailyFocus";

export function isLeisureLiteProfile(profile) {
  const purposeId = Number(profile?.slots?.S?.purposeId);
  const expId = Number(profile?.slots?.M?.experienceLevelId);
  return purposeId === 2 && (!Number.isFinite(expId) || expId <= 0 || expId === 1 || expId === 2);
}

export function isTechnicalProfilingComplete(user, profile) {
  if (user?.isCompetencyblocDone === true) return true;
  if (profile?.isCompetencyblocDone === true) return true;
  if (profile?.profilingProgress?.complete === true) return true;
  return false;
}

export function needsTechnicalProfiling(user, profile) {
  if (isTechnicalProfilingComplete(user, profile)) return false;
  if (isLeisureLiteProfile(profile)) return false;
  return true;
}

function snoozeKey(userId) {
  return `pingflo:techProfileSnooze:${userId || "anon"}`;
}

export function isTechnicalProfilingSnoozed(userId) {
  if (!userId) return false;
  try {
    return sessionStorage.getItem(snoozeKey(userId)) === "1";
  } catch {
    return false;
  }
}

export function snoozeTechnicalProfilingPrompt(userId) {
  if (!userId) return;
  try {
    sessionStorage.setItem(snoozeKey(userId), "1");
  } catch {
    /* ignore */
  }
}

export function clearTechnicalProfilingSnooze(userId) {
  if (!userId) return;
  try {
    sessionStorage.removeItem(snoozeKey(userId));
  } catch {
    /* ignore */
  }
}

export function filterPlaybookSteps(steps, { user, profile } = {}) {
  if (!Array.isArray(steps)) return [];
  return steps.filter((step) => {
    if (step?.skipIf === "technicalProfilingDone" && !needsTechnicalProfiling(user, profile)) {
      return false;
    }
    return true;
  });
}

export function openPlayerTechnicalProfiling({ t, profile, mode } = {}) {
  if (typeof t !== "function") return;
  const complete = isTechnicalProfilingComplete(null, profile);
  const progress = profile?.profilingProgress;
  const isUpdate = mode === "update" || (mode !== "start" && complete);
  const hasPartial = !isUpdate && progress?.answered > 0 && progress?.nextCbKey;
  const seedMessage = isUpdate
    ? t("digipingTechUpdateSeed")
    : hasPartial
      ? t("digipingTechResumeSeed", {
          answered: progress.answered,
          total: progress.total,
          answeredKeys: (progress.answeredCbKeys || []).join(", "),
          nextCbKey: progress.nextCbKey,
        })
      : t("digipingTechOpenSeed");
  openDigitalTwin({
    home_role: "player",
    seedMessage,
    seedVisible: false,
    profilingIntro: isUpdate ? "technicalUpdate" : "technical",
    seedKey: isUpdate
      ? "digipingTechUpdateSeed"
      : hasPartial
        ? "digipingTechResumeSeed"
        : "digipingTechOpenSeed",
    seedParams: hasPartial
      ? {
          answered: progress.answered,
          total: progress.total,
          answeredKeys: (progress.answeredCbKeys || []).join(", "),
          nextCbKey: progress.nextCbKey,
        }
      : null,
  });
}
